import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CheckCircle2, Sparkles, Mail } from 'lucide-react';

const ThankYouPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://fast.wistia.com/player.js";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src = "https://fast.wistia.com/embed/2jlvkeu3p1.js";
    script2.async = true;
    script2.type = "module";
    document.body.appendChild(script2);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: 0,
        currency: 'INR',
        content_name: 'Consultation Booked'
      });
    }
  }, []);

  const nextSteps = [
    {
      title: "Check Your Email",
      description: "You'll receive a confirmation email with all the details for our call."
    },
    {
      title: "Add to Calendar",
      description: "Make sure to add the appointment to your calendar so you don't miss it."
    },
    {
      title: "Prepare Questions",
      description: "Think about your LinkedIn goals and any questions you have for our strategy session."
    }
  ];

  return (
    <div className="thank-you-page">
      <div className="thank-you-glow"></div>

      <div className="container">
        <div className="thank-you-content">
          {/* Success Icon */}
          <div className="success-icon-wrapper">
            <div className="success-icon-circle">
              <CheckCircle2 className="w-16 h-16 success-icon" />
            </div>
          </div>

          {/* Header */}
          <div className="thank-you-header">
            <h1 className="thank-you-title">
              <span className="gradient-text">Congratulations!</span> Your Consultation is Booked
            </h1>
            <p className="thank-you-subtitle">
              We're excited to help you build a LinkedIn brand that generates consistent leads and opportunities.
            </p>
          </div>

          {/* Next Steps */}
          <Card className="next-steps-card">
            <h2 className="next-steps-title">
              <Sparkles className="w-6 h-6 inline mr-2" />
              What Happens Next?
            </h2>
            <div className="next-steps-list">
              {nextSteps.map((step, index) => (
                <div key={index} className="next-step-item">
                  <div className="next-step-number">{index + 1}</div>
                  <div className="next-step-content">
                    <h3 className="next-step-title">{step.title}</h3>
                    <p className="next-step-description">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </Card>

          {/* Bonus Video */}
          <div className="bonus-video-section">
            <h2 className="bonus-video-title">Bonus: Watch This While You Wait</h2>
            <Card className="bonus-video-container">
              <div className="video-wrapper">
                <style>{`wistia-player[media-id='2jlvkeu3p1']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/2jlvkeu3p1/swatch'); display: block; filter: blur(5px); padding-top:56.46%; }`}</style>
                <wistia-player media-id="2jlvkeu3p1" aspect="1.7712177121771218"></wistia-player>
              </div>
            </Card>
          </div>

          {/* Contact Info */}
          <Card className="contact-card">
            <Mail className="w-8 h-8 contact-icon" />
            <h3 className="contact-title">Have Questions?</h3>
            <p className="contact-text">
              Feel free to reach out to us anytime at <a href="mailto:Hi@shivadudigama.com" className="contact-email">Hi@shivadudigama.com</a>
            </p>
          </Card>

          {/* CTA */}
          <div className="thank-you-cta">
            <Button onClick={() => navigate('/')} size="lg" variant="outline" className="cta-button-secondary">
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;